import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import TopBar from './layout/PublicLayout/TopBar';
import LoginModal from './common/modals/LoginModal/LoginModal';
import PropTypes from 'prop-types';
import { MainNavigation, TopNavigation, Slider } from './basic';
import SearchModal from './common/modals/SearchModal/SearchModal';
import { HttpError } from './common/HttpError';
import MiddleLayout from './layout/PublicLayout/MiddleLayout';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ApplicationQuestions from './layout/PublicLayout/Components/ApplicationQuestions/ApplicationQuestions.jsx';

const PublicWrapper = ({ children }) => {
  const { t } = useTranslation();
  const errorStatusCode = useSelector((state) => state.core.errorStatus);
  const errorMessage = useSelector((state) => state.core.apiErrorMessage);

  const Children = () => {
    if (errorStatusCode === 403 || errorStatusCode === 404) {
      return (
        <MiddleLayout hideRightSidebar>
          <HttpError statusCode={errorStatusCode} message={errorMessage} />
        </MiddleLayout>
      );
    }

    return children;
  };

  return (
    <div className="public-layout-page-container">
      <LoginModal />
      <SearchModal />
      <ApplicationQuestions />
      <header>
        <div
          role="toolbar"
          aria-label={t('Odkazy na sociálne siete a zmena jazyka')}
        >
          <TopNavigation />
        </div>
        <nav aria-label={t('Hlavný navigačný panel')}>
          <MainNavigation />
        </nav>
      </header>
      <main>
        <Slider />
        <ClickComponent />
        <Children />
      </main>
    </div>
  );
};

PublicWrapper.propTypes = {
  children: PropTypes.node,
};

const ClickComponent = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const handleClick = (event) => {
      const anchor = event.target.closest('a');
      if (
        anchor &&
        anchor.href &&
        anchor.origin === window.location.origin && // interne linky
        !anchor.hasAttribute('download') &&
        anchor.getAttribute('target') !== '_blank' &&
        !event.defaultPrevented &&
        !anchor.pathname.startsWith('/storage') // neprenaviguj storage
      ) {
        event.preventDefault();
        const href = anchor.pathname + anchor.search + anchor.hash;
        navigate(href);
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, [navigate]);
};

export default PublicWrapper;
